(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1788,6873],{

/***/ 519105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ NoStoreInfoIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(269396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);



function NoStoreInfoIcon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: props.size || 12,
        height: props.size || 12,
        viewBox: "0 0 12 12"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                stroke: "#f58d00",
                fill: "none",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                        cx: 6,
                        cy: 6,
                        r: 6,
                        stroke: "none"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                        cx: 6,
                        cy: 6,
                        r: 5.5
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("text", {
                transform: "translate(4.999 9)",
                fill: "#f58d00",
                fontSize: 8,
                fontFamily: "ProductSans-Bold,Product Sans",
                fontWeight: 700,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tspan", {
                    x: 0,
                    y: 0,
                    children: "i"
                })
            })
        ]
    }));
}


/***/ }),

/***/ 825180:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CheckItemDelivery_CheckItemDelivery; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./src/utils/isDeliveryPincodeBased.js
var isDeliveryPincodeBased = __webpack_require__(984110);
// EXTERNAL MODULE: ./src/assets/svgExports/TickFill.js
var TickFill = __webpack_require__(72084);
// EXTERNAL MODULE: ./src/utils/triggerGetItemDeliveryChages.js + 1 modules
var triggerGetItemDeliveryChages = __webpack_require__(508527);
// EXTERNAL MODULE: ./src/utils/useIsComponentMounted.js
var useIsComponentMounted = __webpack_require__(471778);
// EXTERNAL MODULE: ./src/redux/actions/delivery.js
var delivery = __webpack_require__(679977);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(307297);
// EXTERNAL MODULE: ./src/redux/store/index.js + 45 modules
var store = __webpack_require__(17247);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(150066);
;// CONCATENATED MODULE: ./src/components/CheckItemDelivery/CheckItemDelivery.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  margin-top: 50px;\n  margin-bottom: ",
        "vh;\n  @media screen and (max-width: 767px) {\n    align-items: center;\n    margin-bottom: 0px;\n    padding-top: 20px;\n    margin-top: 0px;\n    margin-left: 18px;\n    padding-bottom: ",
        "px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  font-size: 14px;\n  margin-bottom: 8px;\n  font-weight: 600;\n  font-size: 14px;\n  @media screen and (max-width: 767px) {\n    width: 100%;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 12px;\n  margin-left: -72px;\n  border-radius: 4px;\n  cursor: pointer;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  font-size: 14px;\n  font-weight: 600;\n  color: ",
        ";\n  @media screen and (max-width: 767px) {\n    font-size: 12px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  border: 1px solid #e8e8e8;\n  border-radius: 4px;\n  width: 278px;\n  padding-left: 12px;\n  @media screen and (max-width: 767px) {\n    width: 90.67vw;\n    margin-left: -30px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  @media screen and (max-width: 767px) {\n    width: 100%;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  margin-top: 10px;\n  @media screen and (max-width: 767px) {\n    width: 86vw;\n    padding-bottom: ",
        "px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-left: 8px;\n  font-size: 12px;\n  align-items: center;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  font-size: 12px;\n  margin-top: 4px;\n  margin-left: 25px;\n  ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
var ref, ref1;


var storeInfo = store/* default.getState */.Z.getState().storeReducer.store;
var CheckItemDeliveryContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CheckItemDeliveryContainer",
    componentId: "sc-14141432-0"
})(_templateObject(), function(props) {
    return props.item_charge === undefined ? 0 : 4;
}, function(props) {
    return props.pb;
});
var CheckItemDeliveryHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CheckItemDeliveryHeader",
    componentId: "sc-14141432-1"
})(_templateObject1());
var CheckItemDeliveryInputCtaContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CheckItemDeliveryInputCtaContainer",
    componentId: "sc-14141432-2"
})(_templateObject2());
var CheckItemDeliveryCtaContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CheckItemDeliveryCtaContainer",
    componentId: "sc-14141432-3"
})(_templateObject3());
var CheckItemDeliveryCtaText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CheckItemDeliveryCtaText",
    componentId: "sc-14141432-4"
})(_templateObject4(), storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color);
var CheckItemDeliveryInput = styled_components_browser_esm/* default.input.attrs */.ZP.input.attrs(function(props) {
    return {
        type: "text",
        size: props.size || "1em"
    };
}).withConfig({
    displayName: "CheckItemDeliveryInput",
    componentId: "sc-14141432-5"
})(_templateObject5());
var CheckItemDeliveryHeaderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CheckItemDeliveryHeaderContainer",
    componentId: "sc-14141432-6"
})(_templateObject6());
var SuccessErrorContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SuccessErrorContainer",
    componentId: "sc-14141432-7"
})(_templateObject7(), function(props) {
    return props.pb;
});
var SuccessErrorTopContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SuccessErrorTopContainer",
    componentId: "sc-14141432-8"
})(_templateObject8());
var TickContianer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TickContianer",
    componentId: "sc-14141432-9"
})(_templateObject9());
var DeliveryChargeText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DeliveryChargeText",
    componentId: "sc-14141432-10"
})(_templateObject10());
var SuccessErrorBottomContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SuccessErrorBottomContainer",
    componentId: "sc-14141432-11"
})(_templateObject11(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.itemDeliveryCharges) <= -1 && "color : red ; margin-left : 0px; margin-bottom: 15px";
});

// EXTERNAL MODULE: ./src/components/CheckItemDelivery/constants.js
var constants = __webpack_require__(729465);
// EXTERNAL MODULE: ./src/utils/getItemDetailFromCart.js
var getItemDetailFromCart = __webpack_require__(290129);
;// CONCATENATED MODULE: ./src/components/CheckItemDelivery/CheckItemDelivery.js













/**
 * A Component In which We Can enter Pincode and
 * Check Whether the Item is Servicable or not along with
 * corressponding errors. Using in PDP and QuickView page.
 * used if delivery_type PinCode based.
 * @param {*} props
 * @returns
 */ function CheckItemDelivery(props) {
    var handleInputChange = function handleInputChange(value, maxLength) {
        if (isNaN(value)) {
            value = value.substring(0, value.length - 1);
            value = value.replace(/\D/g, "");
            setPincode(value);
        }
        if (value.length > maxLength) {
            value = value.substring(0, maxLength);
            setPincode(value);
        } else {
            setPincode(value);
        }
    };
    var getDeliveryInfo = function getDeliveryInfo() {
        if (pincode.length === 6 && parseInt(itemId)) {
            var ref;
            // keep amount as item price if item is not added in cart
            var ref1 = (0,getItemDetailFromCart/* default */.Z)(parseInt(itemId)), _amount = ref1.amount, amount = _amount === void 0 ? (props === null || props === void 0 ? void 0 : props.itemsPrice) || 0 : _amount;
            var payload = {
                pincode: pincode,
                pay_amount: amount,
                item_id: parseInt(itemId),
                item_name: itemName
            };
            (0,triggerGetItemDeliveryChages/* triggerGetItemDeliveryCharges */.l)(payload);
            if ((storeData === null || storeData === void 0 ? void 0 : (ref = storeData.services) === null || ref === void 0 ? void 0 : ref.delivery_estimate_flag) === constants/* ESTIMATE_DELIVERY_FLAG.ACTIVE */.F.ACTIVE) {
                payload = {
                    id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
                    text: pincode
                };
                dispatch((0,delivery/* getEstimatedDeliveryTime */.k4)(payload, function(data) {
                    setEstimatedDelivery(data);
                }));
            }
        }
    };
    var successErrorsCondition = function successErrorsCondition() {
        if (itemDeliveryCharges === 0) return "Flat Delivery Charges: " + (deliveryItemsData === null || deliveryItemsData === void 0 ? void 0 : deliveryItemsData.other_delivery_charges);
        else if (itemDeliveryCharges > 0) {
            return "Item Delivery Charges: " + itemDeliveryCharges;
        } else {
            return "Sorry this product can't be delivered at this pincode";
        }
    };
    var renderSuccessErrorMessage = function renderSuccessErrorMessage() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SuccessErrorContainer, {
            pb: props.pb,
            children: [
                itemDeliveryCharges !== -1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(SuccessErrorTopContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TickContianer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TickFill/* TickFill */.v, {
                                width: 17,
                                height: 17,
                                color: "#0DBF44"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryChargeText, {
                            children: "Delivery Available"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessErrorBottomContainer, {
                            itemDeliveryCharges: itemDeliveryCharges,
                            children: successErrorsCondition()
                        }),
                        estimatedDelivery && itemDeliveryCharges !== -1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessErrorBottomContainer, {
                            itemDeliveryCharges: itemDeliveryCharges,
                            children: estimatedDelivery
                        })
                    ]
                })
            ]
        });
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)(""), pincode = ref[0], setPincode = ref[1];
    var ref1 = (0,react.useState)(""), estimatedDelivery = ref1[0], setEstimatedDelivery = ref1[1];
    var ref2 = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return {
            deliveryItemsData: state.deliveryReducer.itemData,
            storeData: state.storeReducer.store,
            cartAmount: (ref = state.cartReducer) === null || ref === void 0 ? void 0 : ref.amount
        };
    }), deliveryItemsData = ref2.deliveryItemsData, storeData = ref2.storeData, cartAmount = ref2.cartAmount;
    var ref3 = (0,react.useState)(0), itemDeliveryCharges = ref3[0], setItemDeliveryCharges = ref3[1];
    var itemId = props.item_id;
    var itemName = props.item_name;
    var isComponentMounted = (0,useIsComponentMounted/* default */.Z)();
    (0,react.useEffect)(function() {
        var ref;
        setItemDeliveryCharges((ref = deliveryItemsData === null || deliveryItemsData === void 0 ? void 0 : deliveryItemsData.item_delivery_charges[itemId]) === null || ref === void 0 ? void 0 : ref.delivery_charges);
    }, [
        deliveryItemsData
    ]);
    (0,react.useEffect)(function() {
        getDeliveryInfo();
    }, [
        cartAmount
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isComponentMounted && (0,isDeliveryPincodeBased/* isDeliveryPincodeBased */.y)() && /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckItemDeliveryContainer, {
            item_charge: itemDeliveryCharges,
            pb: props.pb,
            mb: props.mb,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckItemDeliveryHeaderContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckItemDeliveryHeader, {
                        children: "Check Delivery Charges"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckItemDeliveryInputCtaContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckItemDeliveryInput, {
                            placeholder: "Enter Pincode",
                            value: pincode,
                            type: "text",
                            onChange: function(e) {
                                return handleInputChange(e.target.value, 6);
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckItemDeliveryCtaContainer, {
                            onClick: getDeliveryInfo,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckItemDeliveryCtaText, {
                                children: "Check"
                            })
                        })
                    ]
                }),
                itemDeliveryCharges !== undefined && renderSuccessErrorMessage()
            ]
        })
    });
}
/* harmony default export */ var CheckItemDelivery_CheckItemDelivery = (CheckItemDelivery);


/***/ }),

/***/ 59696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);

var DetailedDescription = function(param) {
    var detailedDescription = param.detailedDescription, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("article", {
                className: "fw6 f6 mb3",
                children: "More Details"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                className: "o-40 mb4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: detailedDescription
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DetailedDescription);


/***/ }),

/***/ 42705:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CouponsAndVouchers_AllProductPagePromos; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/redux/actions/promo.js
var promo = __webpack_require__(168615);
// EXTERNAL MODULE: ./src/utils/getThemeColor.js
var getThemeColor = __webpack_require__(270758);
// EXTERNAL MODULE: ./src/components/CouponsAndVouchers/Common/PromosContainer.tsx
var PromosContainer = __webpack_require__(169708);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./src/assets/svgExports/SliderArrowForward.js
var SliderArrowForward = __webpack_require__(198806);
// EXTERNAL MODULE: ./src/utils/checkClientDeviceType.js
var checkClientDeviceType = __webpack_require__(313508);
;// CONCATENATED MODULE: ./src/components/CouponsAndVouchers/AllProductPagePromos/PromoSections/AllPromos.tsx








var AllPromos = function(param) {
    var productId = param.productId, type = param.type, openPromoModal = param.openPromoModal, _customClasses = param.customClasses, customClasses = _customClasses === void 0 ? "" : _customClasses;
    var getProductAssociatedPromos = function getProductAssociatedPromos() {
        var data = {
            type: type,
            type_ids: [
                productId
            ],
            store_id: storeId,
            user_id: userId
        };
        dispatch((0,promo/* getPromosByTypeAndTypeId */.Lr)(data, function(data) {
            return setPromos(data);
        }));
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    var themeColor = (0,getThemeColor/* getThemeColor */.p)();
    var ref = (0,react.useState)(false), showAllPromos = ref[0], setShowAllPromos = ref[1];
    var ref1 = (0,react.useState)([]), promos = ref1[0], setPromos = ref1[1];
    var ref2 = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return {
            storeId: state.storeReducer.store.store_id,
            userId: ((ref = state.userReducer.data) === null || ref === void 0 ? void 0 : ref.user_id) || 0
        };
    }), storeId = ref2.storeId, userId = ref2.userId;
    (0,react.useEffect)(function() {
        if (productId) {
            getProductAssociatedPromos();
        }
    }, [
        productId
    ]);
    return !!(promos === null || promos === void 0 ? void 0 : promos.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-flex tw-w-full tw-flex-col tw-gap-[12px] tw-pt-[24px] md:tw-gap-[16px] md:tw-border-b md:tw-border-solid md:tw-border-[#E9E9E9] ".concat(customClasses),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "tw-m-0 tw-pl-[16px] tw-text-[16px]/[20px] tw-font-semibold md:tw-pl-0",
                children: "Offers"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PromosContainer/* PromosContainer */.$, {
                promos: showAllPromos ? promos : promos.slice(0, 3),
                onPromoClick: openPromoModal,
                primaryTextClasses: "tw-text-[13px]/[18px] tw-font-medium md:tw-text-[14px]/[20px] md:tw-font-semibold",
                secondaryTextClasses: "tw-text-[12px]/[20px] tw-font-normal md:tw-text-[13px]/[20px]",
                offerStripContainerClasses: "!tw-flex-row tw-justify-between tw-items-center md:tw-items-start ".concat(checkClientDeviceType/* IS_DESKTOP */.yn ? "tw-px-0" : ""),
                offerStripCtaTextOrIcon: !checkClientDeviceType/* IS_DESKTOP */.yn && /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderArrowForward/* default */.Z, {
                    color: "#000000",
                    height: 10,
                    width: 6
                })
            }),
            (promos === null || promos === void 0 ? void 0 : promos.length) > 3 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "tw-m-0 tw-cursor-pointer tw-pb-[20px] tw-pr-[16px] tw-pt-[8px] tw-text-right tw-text-[16px]/[20px] tw-font-semibold md:tw-pb-[10px] md:tw-text-left md:tw-text-[18px]/[20px]",
                style: {
                    color: themeColor
                },
                onClick: function() {
                    return setShowAllPromos(!showAllPromos);
                },
                children: [
                    "View ",
                    showAllPromos ? "less" : "all",
                    " offers"
                ]
            }),
            checkClientDeviceType/* IS_DESKTOP */.yn && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "tw-m-0 tw-pb-[10px] tw-text-[15px]/[20px]",
                children: "*Coupons can be applied at checkout"
            })
        ]
    });
};
/* harmony default export */ var PromoSections_AllPromos = (AllPromos);

// EXTERNAL MODULE: ./src/hooks/useFeatureLocks.ts
var useFeatureLocks = __webpack_require__(482516);
;// CONCATENATED MODULE: ./src/components/CouponsAndVouchers/AllProductPagePromos/index.tsx





var AllProductPagePromos = function(param) {
    var type = param.type, productId = param.productId, _customClasses = param.customClasses, customClasses = _customClasses === void 0 ? "" : _customClasses;
    var openPromoModal = function openPromoModal(promoId) {
        dispatch((0,promo/* togglePromoDetailModal */.wl)({
            show: true,
            promoId: promoId
        }));
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    var couponsFeatureStatus = (0,useFeatureLocks/* useFeatureLocks */.r)().couponsFeatureStatus;
    var isCouponsFeatureLocked = !!(couponsFeatureStatus === null || couponsFeatureStatus === void 0 ? void 0 : couponsFeatureStatus.isLocked);
    return !isCouponsFeatureLocked && /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoSections_AllPromos, {
        productId: productId,
        type: type,
        openPromoModal: openPromoModal,
        customClasses: customClasses
    });
};
/* harmony default export */ var CouponsAndVouchers_AllProductPagePromos = (AllProductPagePromos);


/***/ }),

/***/ 933761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var src_assets_svgExports_OfferIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(493757);
/* harmony import */ var src_hooks_useFeatureLocks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(482516);
/* harmony import */ var src_utils_checkClientDeviceType__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(313508);




var OfferAvailableTag = function(param) {
    var productInfo = param.productInfo, _customClasses = param.customClasses, customClasses = _customClasses === void 0 ? "" : _customClasses;
    var ref;
    var isOfferAvailable = !!(productInfo === null || productInfo === void 0 ? void 0 : (ref = productInfo.promo_offer) === null || ref === void 0 ? void 0 : ref.is_any_promo_offer_available);
    var iconSize = src_utils_checkClientDeviceType__WEBPACK_IMPORTED_MODULE_3__/* .IS_DESKTOP */ .yn ? 14 : 10;
    var couponsFeatureStatus = (0,src_hooks_useFeatureLocks__WEBPACK_IMPORTED_MODULE_2__/* .useFeatureLocks */ .r)().couponsFeatureStatus;
    var isCouponsFeatureLocked = !!(couponsFeatureStatus === null || couponsFeatureStatus === void 0 ? void 0 : couponsFeatureStatus.isLocked);
    return !isCouponsFeatureLocked && isOfferAvailable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
        className: "tw-flex tw-items-center tw-gap-[4px] tw-text-[10px]/[20px] tw-font-medium md:tw-gap-[8px] md:tw-text-[13px]/[20px] ".concat(customClasses),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_assets_svgExports_OfferIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                width: iconSize,
                height: iconSize
            }),
            " Offer available"
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (OfferAvailableTag);


/***/ }),

/***/ 557333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CouponsAndVouchers_SatisfiedBogoPromos; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/redux/actions/promo.js
var promo = __webpack_require__(168615);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(811163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./src/components/CouponsAndVouchers/Common/index.tsx
var Common = __webpack_require__(192134);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(540190);
// EXTERNAL MODULE: ./src/constants/common.ts
var common = __webpack_require__(742783);
;// CONCATENATED MODULE: ./src/components/CouponsAndVouchers/BogoPromoStripPDP/index.tsx







var TrimmedString = function(param) {
    var string = param.string;
    var ref = (0,react.useState)(true), showLess = ref[0], setShowLess = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            string === null || string === void 0 ? void 0 : string.slice(0, showLess ? 100 : 200),
            "...",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "tw-cursor-pointer tw-text-[13px]/[24px] tw-font-semibold",
                onClick: function() {
                    return setShowLess(!showLess);
                },
                children: showLess ? "More" : "Less"
            })
        ]
    });
};
var AvailOfferCTA = function(param) {
    var onClick = param.onClick, isDisabled = param.isDisabled, _customClasses = param.customClasses, customClasses = _customClasses === void 0 ? "" : _customClasses;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: "tw-flex tw-text-nowrap",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Common/* StripCTA */.iQ, {
            onClick: onClick,
            ctaTextOrIcon: "Avail Offer",
            isDisabled: isDisabled,
            customClasses: customClasses
        })
    });
};
var BogoPromoStripPDP = function(param) {
    var _heading = param.heading, heading = _heading === void 0 ? "" : _heading, _description = param.description, description = _description === void 0 ? "" : _description, total = param.total, available = param.available, route = param.route, _showBottomCTA = param.showBottomCTA, showBottomCTA = _showBottomCTA === void 0 ? false : _showBottomCTA, successText = param.successText, isApplicableStatus = param.isApplicableStatus, _isXandYSame = param.isXandYSame, isXandYSame = _isXandYSame === void 0 ? false : _isXandYSame;
    var domain = (0,es/* useSelector */.v9)(function(state) {
        return state.storeReducer.store.domain;
    });
    var onAvailOffer = function() {
        router_default().push((0,routes.getRoute)(route, domain));
    };
    var renderDescription = function(desc) {
        if (desc.length < 100) {
            return desc;
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TrimmedString, {
                string: desc
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Common/* StripContainer */.P6, {
        customClasses: "!tw-flex-row tw-justify-between tw-items-center md:tw-items-start !tw-gap-[32px] tw-p-[16px] md:tw-px-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Common/* StripIconInfoWrapper */.To, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Common/* StripOfferIcon */.YT, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-flex-col tw-gap-[2px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "tw-m-0 tw-text-[13px]/[18px] tw-font-medium md:tw-text-[14px]/[20px] md:tw-font-semibold",
                                children: heading
                            }),
                            !!description && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "tw-m-0 tw-text-[13px]/[20px] tw-font-normal",
                                children: renderDescription(description)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "tw-m-0 tw-flex tw-gap-[10px] tw-text-[12px]/[24px] tw-font-medium tw-text-[#737373]",
                                children: [
                                    "Item added ",
                                    available,
                                    "/",
                                    total,
                                    !!successText && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "te-text-[12px]/[24px] tw-font-medium tw-text-[#24AC21]",
                                        children: successText
                                    })
                                ]
                            }),
                            showBottomCTA && !isXandYSame && /*#__PURE__*/ (0,jsx_runtime.jsx)(AvailOfferCTA, {
                                onClick: onAvailOffer,
                                isDisabled: isApplicableStatus === common/* TRIGGERED_PROMO_STATUSES.PROMO_X_AND_Y_SATISFIED */.Tt.PROMO_X_AND_Y_SATISFIED,
                                customClasses: "!tw-ml-0 !tw-mt-[8px]"
                            })
                        ]
                    })
                ]
            }),
            !showBottomCTA && !isXandYSame && /*#__PURE__*/ (0,jsx_runtime.jsx)(AvailOfferCTA, {
                onClick: onAvailOffer,
                isDisabled: total === available
            })
        ]
    });
};
/* harmony default export */ var CouponsAndVouchers_BogoPromoStripPDP = (BogoPromoStripPDP);

// EXTERNAL MODULE: ./src/hooks/useFeatureLocks.ts
var useFeatureLocks = __webpack_require__(482516);
// EXTERNAL MODULE: ./src/utils/checkClientDeviceType.js
var checkClientDeviceType = __webpack_require__(313508);
// EXTERNAL MODULE: ./src/utils/debounce.js
var debounce = __webpack_require__(374118);
;// CONCATENATED MODULE: ./src/components/CouponsAndVouchers/SatisfiedBogoPromos/index.tsx








function getEligibleBogoPromos(payload, dispatch, callback) {
    dispatch((0,promo/* getSatisfiedBogoPromos */.tD)(payload, callback));
}
var debounceGetSatisfiedBogoPromos = (0,debounce/* debounce */.D)(getEligibleBogoPromos, 300);
var SatisfiedBogoPromos = function(param) {
    var _type = param.type, type = _type === void 0 ? null : _type, productId = param.productId, _showBottomCTA = param.showBottomCTA, showBottomCTA = _showBottomCTA === void 0 ? false : _showBottomCTA, _customClasses = param.customClasses, customClasses = _customClasses === void 0 ? "" : _customClasses;
    var ref;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref1 = (0,react.useState)([]), promos = ref1[0], setPromos = ref1[1];
    var ref2 = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return {
            cartData: state.cartReducer,
            latestSyncedCart: state.commonReducer.latestSyncedCart,
            storeId: (ref = state.storeReducer.store) === null || ref === void 0 ? void 0 : ref.store_id
        };
    }), cartData = ref2.cartData, latestSyncedCart = ref2.latestSyncedCart, storeId = ref2.storeId;
    var couponsFeatureStatus = (0,useFeatureLocks/* useFeatureLocks */.r)().couponsFeatureStatus;
    var isCouponsFeatureLocked = !!(couponsFeatureStatus === null || couponsFeatureStatus === void 0 ? void 0 : couponsFeatureStatus.isLocked);
    (0,react.useEffect)(function() {
        var ref;
        if (latestSyncedCart && (latestSyncedCart === null || latestSyncedCart === void 0 ? void 0 : (ref = latestSyncedCart.items) === null || ref === void 0 ? void 0 : ref.length) && storeId) {
            var payload = {
                current_product_id: productId,
                cart: cartData
            };
            debounceGetSatisfiedBogoPromos(payload, dispatch, function(data) {
                return setPromos(data);
            });
        }
    }, [
        latestSyncedCart,
        storeId
    ]);
    return !isCouponsFeatureLocked && !!promos.length && !!(cartData === null || cartData === void 0 ? void 0 : (ref = cartData.items) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tw-flex tw-w-full tw-flex-col md:tw-pt-[24px] ".concat(customClasses),
        children: promos === null || promos === void 0 ? void 0 : promos.map(function(param, index) {
            var id = param.id, heading = param.heading, description = param.description, total_count = param.total_count, current_count = param.current_count, success_text = param.success_text, is_applicable = param.is_applicable, is_same = param.is_same;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponsAndVouchers_BogoPromoStripPDP, {
                heading: heading,
                description: description,
                total: total_count,
                available: current_count,
                route: "/offer-page?promo_id=".concat(id, "&is_reward=1"),
                showBottomCTA: showBottomCTA || !checkClientDeviceType/* IS_DESKTOP */.yn,
                successText: success_text,
                isApplicableStatus: is_applicable,
                isXandYSame: is_same
            }, index);
        })
    });
};
/* harmony default export */ var CouponsAndVouchers_SatisfiedBogoPromos = (SatisfiedBogoPromos);


/***/ }),

/***/ 532890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(913886);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(667294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(225617);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96031);





var NotifyProduct = function(props) {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    var storeInfo = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return {
            storeInfo: state.storeReducer.store
        };
    }).storeInfo;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), emailInput = ref[0], setEmailInput = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), errorText = ref1[0], showErrorText = ref1[1];
    var handleInputChange = function(e) {
        setEmailInput(e.target.value);
        showErrorText(false);
    };
    var validateEmail = function(email) {
        return email.match(_utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .EMAIL_REGEX */ .CU);
    };
    var handleCTABtnClick = function() {
        var ref, ref1;
        if (!validateEmail(emailInput)) {
            showErrorText(true);
            setEmailInput("");
            return;
        }
        var payload = {
            store_id: storeInfo.store_id,
            item_id: props === null || props === void 0 ? void 0 : (ref = props.product) === null || ref === void 0 ? void 0 : ref.id,
            variant_id: props === null || props === void 0 ? void 0 : (ref1 = props.activeVariant) === null || ref1 === void 0 ? void 0 : ref1.variant_id,
            customer_email: emailInput
        };
        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_4__/* .addNotifyProductInquiry */ .TW)(payload, function() {
            setEmailInput("");
        }));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "notify-product-container",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "heading",
                children: "This product is temporarily out of stock"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "subheading",
                children: "Share your email and we will inform you when the product is in stock"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "notify-product-input-container",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        type: "text",
                        placeholder: "Enter email address",
                        className: "notify-product-input-box",
                        value: emailInput,
                        onChange: handleInputChange
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        className: "notify-cta-btn",
                        onClick: handleCTABtnClick,
                        children: "Notify Me"
                    })
                ]
            }),
            errorText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "invalid-email-text",
                style: {
                    color: "#EB5757"
                },
                children: "Please enter a valid email address"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NotifyProduct);


/***/ }),

/***/ 748577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ MediaContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(269396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var src_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(268037);




function MediaContainer(props) {
    var getDimensions = function getDimensions() {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, width ? {
            width: width
        } : {}, height ? {
            height: height
        } : {});
    };
    var _onClick = props.onClick, onClick = _onClick === void 0 ? null : _onClick, _onMouseEnter = props.onMouseEnter, onMouseEnter = _onMouseEnter === void 0 ? null : _onMouseEnter, _onMouseLeave = props.onMouseLeave, onMouseLeave = _onMouseLeave === void 0 ? null : _onMouseLeave, _isSelected = props.isSelected, isSelected = _isSelected === void 0 ? false : _isSelected, _containerClasses = props.containerClasses, containerClasses = _containerClasses === void 0 ? "" : _containerClasses, _width = props.width, width = _width === void 0 ? null : _width, _height = props.height, height = _height === void 0 ? null : _height, _borderWidth = props.borderWidth, borderWidth = _borderWidth === void 0 ? 0.6 : _borderWidth, _borderColor = props.borderColor, borderColor = _borderColor === void 0 ? "#858585" : _borderColor, children = props.children;
    var ref = (0,src_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSSRSelector */ .kF)(function(state) {
        return {
            theme: state.storeReducer.store.theme
        };
    }), _theme = ref.theme, product_aspect_ratio = _theme.product_aspect_ratio, tmp = _theme.product_base_image_color, backgroundColor = tmp === void 0 ? "#FFFFFF" : tmp;
    var aspectRatio = product_aspect_ratio || 100; // Fallback aspect ratio if backend sends 0
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "relative tw-flex tw-items-center tw-justify-center  tw-overflow-hidden ".concat(containerClasses),
        style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, getDimensions()), {
            borderStyle: isSelected ? "solid" : "none",
            borderWidth: borderWidth,
            borderColor: borderColor,
            aspectRatio: aspectRatio / 100,
            backgroundColor: backgroundColor
        }),
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        children: children
    });
}


/***/ }),

/***/ 431937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ProductScheduler; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/KeyboardArrowRight.js
var KeyboardArrowRight = __webpack_require__(626602);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/HighlightOff.js
var HighlightOff = __webpack_require__(653592);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/LocalizationProvider/LocalizationProvider.js
var LocalizationProvider = __webpack_require__(550720);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/DateCalendar/DateCalendar.js + 28 modules
var DateCalendar = __webpack_require__(816042);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/AdapterDayjs/AdapterDayjs.js
var AdapterDayjs = __webpack_require__(510586);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(727484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./src/components/BasicModal/index.tsx
var BasicModal = __webpack_require__(475868);
;// CONCATENATED MODULE: ./src/components/ProductScheduler/constants.ts
var SCREENS = {
    DATE: 0,
    SLOT: 1
};
var TIME_RANGE_TYPES = {
    DAY: "day",
    MONTH: "month"
};

// EXTERNAL MODULE: ./src/components/ProductScheduler/utils.ts
var utils = __webpack_require__(897713);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/InfoOutlined.js
var InfoOutlined = __webpack_require__(136804);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(730381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(307297);
// EXTERNAL MODULE: ./src/utils/getThemeColor.js
var getThemeColor = __webpack_require__(270758);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(150066);
// EXTERNAL MODULE: ./src/utils/checkClientDeviceType.js
var checkClientDeviceType = __webpack_require__(313508);
;// CONCATENATED MODULE: ./src/components/ProductScheduler/TimeSlot.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &:hover {\n    border-color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var StyledDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "StyledDiv",
    componentId: "sc-ca16c80b-0"
})(_templateObject(), function(props) {
    return props.hoverColor || "#D5D5D5";
});
var TimeSlot = function(param) {
    var slot = param.slot, isDisabled = param.isDisabled, isSelected = param.isSelected, onClick = param.onClick;
    var getVriableClasses = function getVriableClasses() {
        switch(true){
            case isDisabled:
                return "tw-border-none hover:!tw-border-none tw-pointer-events-none";
            case isSelected:
                return "tw-border-solid tw-font-semibold tw-pointer-events-none";
            default:
                return "tw-border-solid tw-border-[#D5D5D5] tw-cursor-pointer";
        }
    };
    var getInlineStyle = function getInlineStyle() {
        switch(true){
            case isDisabled:
                return {
                    backgroundColor: "#F0F0F0",
                    color: "#B2B2B2"
                };
            case isSelected:
                return {
                    backgroundColor: themeColor + "0D",
                    borderColor: themeColor,
                    color: themeColor
                };
            default:
                return {};
        }
    };
    var themeColor = (0,getThemeColor/* getThemeColor */.p)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDiv, {
        className: "tw-flex tw-justify-center tw-rounded-[4px] tw-border tw-py-[12px] ".concat(getVriableClasses()),
        style: getInlineStyle(),
        hoverColor: !isDisabled && !isSelected && checkClientDeviceType/* IS_DESKTOP */.yn ? themeColor : null,
        onClick: onClick,
        children: [
            (0,utils/* convertTo12HourFormat */.YZ)(slot.from),
            " - ",
            (0,utils/* convertTo12HourFormat */.YZ)(slot.to)
        ]
    });
};
/* harmony default export */ var ProductScheduler_TimeSlot = (TimeSlot);

;// CONCATENATED MODULE: ./src/components/ProductScheduler/ScheduleSelectionModal.tsx













var ScheduleSelectionModal = function(param) {
    var scheduleInfo = param.scheduleInfo, setScheduleInfo = param.setScheduleInfo, schedualerConstraints = param.schedualerConstraints, onClose = param.onClose;
    var getScreenHeading = function getScreenHeading() {
        return activeScreen === SCREENS.DATE ? "Select a date" : "Select a time slot";
    };
    var isSlotAfter2Hrs = function isSlotAfter2Hrs(slot) {
        var slotStartTime = moment_default()(slot.from, "HH:mm:ss");
        return slotStartTime.isAfter(moment_default()().add(2, "hours"));
    };
    var getMaxSelectableDateInMS = function getMaxSelectableDateInMS(today) {
        var ref, ref1;
        return schedualerConstraints.days_range.type === TIME_RANGE_TYPES.DAY ? today.setDate(today.getDate() + (schedualerConstraints === null || schedualerConstraints === void 0 ? void 0 : (ref = schedualerConstraints.days_range) === null || ref === void 0 ? void 0 : ref.value)) : today.setMonth(today.getMonth() + (schedualerConstraints === null || schedualerConstraints === void 0 ? void 0 : (ref1 = schedualerConstraints.days_range) === null || ref1 === void 0 ? void 0 : ref1.value));
    };
    var getMinSelectableDateInMS = function getMinSelectableDateInMS(today) {
        var slots = (schedualerConstraints === null || schedualerConstraints === void 0 ? void 0 : schedualerConstraints.ranges) || [];
        var isAnySlotAfter2Hrs = slots.some(isSlotAfter2Hrs);
        return isAnySlotAfter2Hrs ? today : today.setDate(today.getDate() + 1);
    };
    var toggleActiveScreen = function toggleActiveScreen() {
        setActiveScreen(activeScreen ? 0 : 1);
    };
    var handleDateChange = function handleDateChange(newDate) {
        if (hasSlots) {
            setDateInfoLocal(newDate);
            toggleActiveScreen();
        } else {
            setScheduleInfo({
                date: (0,utils/* formatDate */.p6)(new Date(newDate)),
                time: null
            });
            onClose();
        }
    };
    var handleSaveSchedulingInfo = function handleSaveSchedulingInfo() {
        if (hasSlots && !slotInfoLocal) {
            setShowError(true);
        } else {
            setScheduleInfo({
                date: (0,utils/* formatDate */.p6)(new Date(dateInfoLocal)),
                time: slotInfoLocal
            });
            onClose();
        }
    };
    var renderAllTimeSlots = function renderAllTimeSlots() {
        var ref;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: "tw-grid tw-grid-cols-1 tw-gap-x-[20px] tw-gap-y-[12px] tw-text-[14px]/[17px] md:tw-grid-cols-2",
            children: schedualerConstraints === null || schedualerConstraints === void 0 ? void 0 : (ref = schedualerConstraints.ranges) === null || ref === void 0 ? void 0 : ref.map(function(slot, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductScheduler_TimeSlot, {
                    slot: slot,
                    isDisabled: isToday && !isSlotAfter2Hrs(slot),
                    isSelected: (slotInfoLocal === null || slotInfoLocal === void 0 ? void 0 : slotInfoLocal.from) === (slot === null || slot === void 0 ? void 0 : slot.from) && slotInfoLocal.to === (slot === null || slot === void 0 ? void 0 : slot.to),
                    onClick: function() {
                        setShowError(false);
                        setSlotInfoLocal(slot);
                    }
                }, index);
            })
        });
    };
    var renderErrorMessage = function renderErrorMessage() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            className: "tw-flex tw-items-center tw-gap-[10px] tw-text-[14px]/[17px] tw-font-medium tw-text-[#BC241D]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoOutlined/* default */.Z, {
                    color: "inherit",
                    fontSize: "small"
                }),
                " Please select a time slot to schedule a booking"
            ]
        });
    };
    var renderSaveButton = function renderSaveButton() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tw-absolute tw-bottom-[0] tw-left-[0] tw-right-[0] tw-bg-white tw-p-[16px] tw-pb-[16px] md:tw-p-[24px] ",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-flex tw-cursor-pointer tw-justify-center tw-rounded-[4px] tw-py-[12px] tw-text-[14px]/[17px] tw-text-white",
                onClick: handleSaveSchedulingInfo,
                style: {
                    backgroundColor: slotInfoLocal ? themeColor : "#00000066"
                },
                children: "Save date and slot"
            })
        });
    };
    var ref;
    var themeColor = (0,getThemeColor/* getThemeColor */.p)();
    var ref1 = (0,react.useState)(null), dateInfoLocal = ref1[0], setDateInfoLocal = ref1[1];
    var ref2 = (0,react.useState)(null), slotInfoLocal = ref2[0], setSlotInfoLocal = ref2[1];
    var ref3 = (0,react.useState)(SCREENS.DATE), activeScreen = ref3[0], setActiveScreen = ref3[1];
    var ref4 = (0,react.useState)(false), showError = ref4[0], setShowError = ref4[1];
    var isToday = dateInfoLocal === null || dateInfoLocal === void 0 ? void 0 : dateInfoLocal.isSame(moment_default()(), "day");
    var hasSlots = !!(schedualerConstraints === null || schedualerConstraints === void 0 ? void 0 : (ref = schedualerConstraints.ranges) === null || ref === void 0 ? void 0 : ref.length);
    (0,react.useEffect)(function() {
        if (scheduleInfo) {
            var ref, ref1;
            setSlotInfoLocal((scheduleInfo === null || scheduleInfo === void 0 ? void 0 : scheduleInfo.time) || null);
            setDateInfoLocal(dayjs_min_default()((0,utils/* parseFormattedDate */.Pi)(scheduleInfo === null || scheduleInfo === void 0 ? void 0 : scheduleInfo.date)));
            (scheduleInfo === null || scheduleInfo === void 0 ? void 0 : (ref = scheduleInfo.time) === null || ref === void 0 ? void 0 : ref.from) && (scheduleInfo === null || scheduleInfo === void 0 ? void 0 : (ref1 = scheduleInfo.time) === null || ref1 === void 0 ? void 0 : ref1.to) && toggleActiveScreen();
        }
    }, [
        scheduleInfo
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicModal/* default */.Z, {
        show: true,
        onClose: onClose,
        heading: getScreenHeading(),
        customClasses: "md:!tw-max-w-[480px] !tw-min-w-fit !tw-h-[500px]",
        headingClasses: "!tw-border-none !tw-pt-[32px] !tw-px-[16px] md:!tw-px-[24px] tw-text-[24px]/[28px]",
        customCloseIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(HighlightOff["default"], {
            className: "tw-absolute tw-right-[16px] tw-top-[16px] tw-flex-1 tw-cursor-pointer",
            onClick: onClose
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tw-flex-1 tw-overflow-scroll tw-px-[16px] tw-pb-[88px] tw-pt-[16px] md:tw-px-[24px] md:tw-pb-[32px]",
            children: activeScreen === SCREENS.DATE ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalizationProvider/* LocalizationProvider */._, {
                dateAdapter: AdapterDayjs/* AdapterDayjs */.y,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DateCalendar/* DateCalendar */.W, {
                    className: "md:tw-scale-110",
                    minDate: dayjs_min_default()(new Date(getMinSelectableDateInMS(new Date()))),
                    maxDate: dayjs_min_default()(new Date(getMaxSelectableDateInMS(new Date()))),
                    disableHighlightToday: true,
                    value: dateInfoLocal,
                    onChange: handleDateChange
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-flex-1 tw-flex-col tw-gap-[32px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-flex-col tw-gap-[12px] tw-text-[16px]/[20px] ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-flex tw-justify-between tw-font-semibold",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Date: "
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "tw-cursor-pointer",
                                        style: {
                                            color: themeColor
                                        },
                                        onClick: toggleActiveScreen,
                                        children: "Edit date"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "tw-font-normal tw-text-[#6B6B6B]",
                                children: (0,utils/* formatDate */.p6)(new Date(dateInfoLocal))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-flex-col tw-gap-[12px] tw-text-[16px]/[20px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-flex tw-justify-between tw-font-semibold",
                                children: "Select a time slot"
                            }),
                            renderAllTimeSlots()
                        ]
                    }),
                    showError && renderErrorMessage(),
                    renderSaveButton()
                ]
            })
        })
    });
};
/* harmony default export */ var ProductScheduler_ScheduleSelectionModal = (ScheduleSelectionModal);

// EXTERNAL MODULE: ./src/utils/getStoreType.js
var getStoreType = __webpack_require__(66871);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
// EXTERNAL MODULE: ./src/redux/index.ts
var redux = __webpack_require__(268037);
;// CONCATENATED MODULE: ./src/components/ProductScheduler/index.tsx









var ProductScheduler = function(param) {
    var schedualerConstraints = param.schedualerConstraints, showSchedulerError = param.showSchedulerError, scheduleInfo = param.scheduleInfo, setScheduleInfo = param.setScheduleInfo, _customClasses = param.customClasses, customClasses = _customClasses === void 0 ? "" : _customClasses;
    var getScheduleInfoStr = function getScheduleInfoStr() {
        var ref = scheduleInfo || {}, _date = ref.date, date = _date === void 0 ? null : _date, _time = ref.time, time = _time === void 0 ? null : _time;
        switch(true){
            case !!date && !!time:
                return "".concat(date, ", ").concat((0,utils/* convertTo12HourFormat */.YZ)(time === null || time === void 0 ? void 0 : time.from), " - ").concat((0,utils/* convertTo12HourFormat */.YZ)(time === null || time === void 0 ? void 0 : time.to));
            case !!date:
                return date;
            case !!time:
                return "".concat((0,utils/* convertTo12HourFormat */.YZ)(time === null || time === void 0 ? void 0 : time.from), " - ").concat((0,utils/* convertTo12HourFormat */.YZ)(time === null || time === void 0 ? void 0 : time.to));
            default:
                return "";
        }
    };
    var getLabel = function getLabel() {
        return !(scheduleInfo === null || scheduleInfo === void 0 ? void 0 : scheduleInfo.date) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "Schedule a booking",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "tw-text-[12px]/[17px] tw-font-bold",
                    style: {
                        color: themeColor
                    },
                    children: "NEW"
                })
            ]
        }) : "Manage your booking";
    };
    var ref, ref1;
    var themeColor = (0,getThemeColor/* getThemeColor */.p)();
    var ref2 = (0,react.useState)(false), showSelectionModal = ref2[0], setShowSelectionModal = ref2[1];
    var schedulerRef = (0,react.useRef)(null);
    var storeData = (0,redux/* useSSRSelector */.kF)(function(state) {
        return state.storeReducer.store;
    });
    var isB2bStore = (0,getStoreType/* getStoreType */.K)(storeData) === constants/* STORE_CUSTOMIZATION.B2B */.DO.B2B;
    (0,react.useEffect)(function() {
        if (showSchedulerError && schedulerRef.current) {
            var ref, ref1;
            (ref = schedulerRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.scrollIntoView) === null || ref1 === void 0 ? void 0 : ref1.call(ref);
        }
    }, [
        showSchedulerError
    ]);
    return schedualerConstraints && !isB2bStore && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                ref: schedulerRef,
                className: "tw-flex tw-flex-col tw-gap-[10px] tw-px-[16px] tw-text-[14px]/[17px] md:tw-max-w-[500px] md:tw-px-0 md:tw-pt-[32px] ".concat(customClasses),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        className: "tw-flex tw-gap-[8px] tw-text-[#414141]",
                        children: getLabel()
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-cursor-pointer tw-items-center tw-border tw-border-solid tw-border-[#D5D5D5] tw-px-[16px] tw-py-[12px] tw-font-normal",
                        onClick: function() {
                            return setShowSelectionModal(true);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                value: getScheduleInfoStr(),
                                placeholder: "Select a date ".concat((schedualerConstraints === null || schedualerConstraints === void 0 ? void 0 : (ref = schedualerConstraints.ranges) === null || ref === void 0 ? void 0 : ref.length) ? "& time" : ""),
                                className: "tw-h-full tw-flex-1 tw-cursor-pointer tw-border-none tw-bg-transparent tw-text-[14px]/[17px] tw-caret-transparent placeholder:tw-text-[#999999]",
                                readOnly: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowRight/* default */.Z, {})
                        ]
                    }),
                    showSchedulerError && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "tw-m-0 tw-text-[14px]/[17px] tw-text-[#BC241D]",
                        children: [
                            "Please select a date",
                            (schedualerConstraints === null || schedualerConstraints === void 0 ? void 0 : (ref1 = schedualerConstraints.ranges) === null || ref1 === void 0 ? void 0 : ref1.length) ? " & time" : "",
                            " to continue"
                        ]
                    })
                ]
            }),
            showSelectionModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductScheduler_ScheduleSelectionModal, {
                scheduleInfo: scheduleInfo,
                setScheduleInfo: setScheduleInfo,
                onClose: function() {
                    return setShowSelectionModal(false);
                },
                schedualerConstraints: schedualerConstraints
            })
        ]
    });
};
/* harmony default export */ var components_ProductScheduler = (ProductScheduler);


/***/ }),

/***/ 18468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var _CouponsAndVouchers_OfferAvailableTag__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(933761);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(673220);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var setBackgroundColor = function(rating) {
    if (rating < 2) return "#F54C52";
    if (rating < 3) return "#FF9F00";
    if (rating < 4) return "#66BB6A";
    if (rating < 5) return "#43A047";
    return "#2E7D32";
};
var RatingBox = function(param) {
    var isVisible = param.isVisible, rating = param.rating, _ratingsCount = param.ratingsCount, ratingsCount = _ratingsCount === void 0 ? undefined : _ratingsCount, _isNewStyledRatingBox = param.isNewStyledRatingBox, isNewStyledRatingBox = _isNewStyledRatingBox === void 0 ? false : _isNewStyledRatingBox, _productInfo = param.productInfo, productInfo = _productInfo === void 0 ? null : _productInfo, _isPdp = param.isPdp, isPdp = _isPdp === void 0 ? false : _isPdp, _ratingCountColor = param.ratingCountColor, ratingCountColor = _ratingCountColor === void 0 ? "#44454a" : _ratingCountColor;
    return isVisible && rating ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().ratingBoxContainer),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().ratingBox), " ").concat(isNewStyledRatingBox ? (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().updatedRatingBox) : ""),
                    style: {
                        backgroundColor: setBackgroundColor(rating)
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "mv0 pr4px ".concat(isNewStyledRatingBox ? (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().updatedNoOfRating) : ""),
                            children: Number.isInteger(rating) ? rating : rating.toFixed(1)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            alt: "Rating Star",
                            src: isNewStyledRatingBox ? "/assets/images/green-star.svg" : "/assets/images/white-star.svg",
                            width: "12px",
                            height: "11px"
                        })
                    ]
                }),
                ratingsCount && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "mv0",
                    style: {
                        color: ratingCountColor
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: ratingsCount
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CouponsAndVouchers_OfferAvailableTag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    productInfo: productInfo,
                    customClasses: "tw-ml-[12px]"
                })
            ]
        })
    }) : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (RatingBox);


/***/ }),

/***/ 853724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ReviewsSection; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(629815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
;// CONCATENATED MODULE: ./src/components/RatingStar/index.js

var RatingStar = function(param) {
    var rating = param.rating;
    var getImageUrl = function getImageUrl() {
        switch(true){
            case rating < 2:
                return "/assets/images/red-star.svg";
            case rating < 3:
                return "/assets/images/orange-star.svg";
            case rating < 4:
                return "/assets/images/light-green-star.svg";
            case rating < 5:
                return "/assets/images/green-star.svg";
            default:
                return "/assets/images/dark-green-star.svg";
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        alt: "Rating 5 Star",
        src: getImageUrl(),
        width: 30,
        height: 30
    });
};
/* harmony default export */ var components_RatingStar = (RatingStar);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/react-tooltip/dist/index.es.js + 3 modules
var index_es = __webpack_require__(924762);
// EXTERNAL MODULE: ./src/components/ReviewsSection/index.module.scss
var index_module = __webpack_require__(325525);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(730381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./src/assets/svgExports/VerifiedBadge.js

function VerifiedBadge(param) {
    var _size = param.size, size = _size === void 0 ? 18 : _size;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9 1.08887L2.25 3.54376V9.00012C2.25 15.1656 8.80005 16.8427 8.86597 16.8592L9 16.8916L9.13403 16.8592C9.19995 16.8427 15.75 15.1656 15.75 9.00012V3.54376L9 1.08887ZM14.625 9.00012C14.625 13.8819 9.89484 15.4727 9.0022 15.7292C8.14142 15.4744 3.375 13.8401 3.375 9.00012V4.33148L9 2.28638L14.625 4.33148V9.00012Z",
                fill: "#2B74D8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.02271 8.60254L5.22729 9.39795L7.875 12.0457L12.7727 7.14795L11.9773 6.35254L7.875 10.4548L6.02271 8.60254Z",
                fill: "#2B74D8"
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/RatingBox/index.js
var RatingBox = __webpack_require__(18468);
// EXTERNAL MODULE: ./src/components/ReviewsSection/constants.js
var constants = __webpack_require__(601829);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/PlayCircleOutlineRounded.js
var PlayCircleOutlineRounded = __webpack_require__(223151);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(693967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./src/components/ReviewsSection/Common/index.tsx






function VerifiedBuyerBadge(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        className: "tw-flex tw-items-center tw-gap-[2px] tw-text-[14px]/[18px] tw-font-semibold tw-italic tw-text-[#2B74D8] ".concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VerifiedBadge, {}),
            " Verified Buyer"
        ]
    });
}
function ReviewerInfo(param) {
    var review = param.review;
    var contact = (review === null || review === void 0 ? void 0 : review.full_name) || (review === null || review === void 0 ? void 0 : review.phone) || (review === null || review === void 0 ? void 0 : review.email);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-flex tw-flex-col tw-gap-[12px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-gap-[12px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingBox/* default */.Z, {
                        isVisible: !!(review === null || review === void 0 ? void 0 : review.rating),
                        rating: review === null || review === void 0 ? void 0 : review.rating,
                        isNewStyledRatingBox: false
                    }),
                    !!(review === null || review === void 0 ? void 0 : review.verified_buyer) && /*#__PURE__*/ (0,jsx_runtime.jsx)(VerifiedBuyerBadge, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "tw-m-0 tw-text-[12px]/[18px] tw-font-normal tw-text-[#00000094]",
                children: [
                    "Reviewed on",
                    " ",
                    new Date(review === null || review === void 0 ? void 0 : review.review_date).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "long",
                        year: "numeric"
                    }),
                    " ",
                    !!contact && "by ".concat(contact)
                ]
            })
        ]
    });
}
function ReviewMediaRendered(param) {
    var media = param.media, onClick = param.onClick, _size = param.size, size = _size === void 0 ? 110 : _size;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("border-grey1 tw-relative tw-flex tw-flex-shrink-0 tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-[4px] tw-object-contain", onClick ? "tw-cursor-pointer" : ""),
        onClick: onClick,
        style: {
            width: size,
            height: size
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: (media === null || media === void 0 ? void 0 : media.thumbnail_url) || (media === null || media === void 0 ? void 0 : media.media_url),
                className: "!tw-h-auto tw-max-h-full !tw-w-auto tw-max-w-full"
            }),
            (media === null || media === void 0 ? void 0 : media.media_type) === constants/* REVIEW_MEDIA_TYPE.VIDEO */.x.VIDEO && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-absolute tw-inset-0 tw-bg-[#00000059]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "tw-absolute tw-left-[50%] tw-top-[50%] tw-flex -tw-translate-x-1/2 -tw-translate-y-1/2 tw-text-white",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayCircleOutlineRounded["default"], {})
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/utils/checkClientDeviceType.js
var checkClientDeviceType = __webpack_require__(313508);
;// CONCATENATED MODULE: ./src/components/ReviewsSection/CustomerReviewReply.js










var CustomerReviewReply = function(param) {
    var review = param.review, handleProductReviewModalOpen = param.handleProductReviewModalOpen;
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,react.useState)({
        review: false,
        reply: false
    }), showCompleteReviewAndReply = ref5[0], setShowCompleteReviewAndReply = ref5[1];
    var userData = (0,es/* useSelector */.v9)(function(state) {
        return {
            userData: state.userReducer
        };
    }).userData;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tw-border-b tw-border-solid tw-border-[#E2E2E2] last:tw-border-none last:tw-border-transparent",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (index_module_default()).customerReviewReplyContainer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewerInfo, {
                            review: review
                        }),
                        (userData === null || userData === void 0 ? void 0 : userData.isLogin) && review.phone === (userData === null || userData === void 0 ? void 0 : (ref = userData.data) === null || ref === void 0 ? void 0 : ref.phone) && !review.status ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/assets/images/clock-timer.svg",
                                    className: "pointer",
                                    "data-tip": true,
                                    "data-for": "review-under-process"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                                    id: "review-under-process",
                                    place: "bottom",
                                    effect: "solid",
                                    multiline: true,
                                    padding: "8px",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mv0 fw5 f12px",
                                        children: "Review under process"
                                    })
                                })
                            ]
                        }) : null
                    ]
                }),
                !!(review === null || review === void 0 ? void 0 : (ref1 = review.store_item_review_media) === null || ref1 === void 0 ? void 0 : ref1.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-mt-[12px] tw-flex tw-gap-[16px]",
                    children: review === null || review === void 0 ? void 0 : (ref2 = review.store_item_review_media) === null || ref2 === void 0 ? void 0 : ref2.map(function(media, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewMediaRendered, {
                            media: media,
                            size: checkClientDeviceType/* IS_MOBILE */.q$ ? 84 : 88,
                            onClick: function() {
                                return handleProductReviewModalOpen(index);
                            }
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "pt12px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "mv0 tw-text-[14px]/[18px] tw-font-normal tw-text-[#111C36]",
                            children: showCompleteReviewAndReply.review ? review === null || review === void 0 ? void 0 : review.review : review === null || review === void 0 ? void 0 : (ref3 = review.review) === null || ref3 === void 0 ? void 0 : ref3.substr(0, 219)
                        }),
                        (review === null || review === void 0 ? void 0 : review.review).length > 219 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: (index_module_default()).readMore,
                            onClick: function() {
                                return setShowCompleteReviewAndReply(function(prevState) {
                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                                        review: !showCompleteReviewAndReply.review
                                    });
                                });
                            },
                            children: [
                                "... Read ",
                                showCompleteReviewAndReply.review ? "Less" : "More"
                            ]
                        }) : ""
                    ]
                }),
                (review === null || review === void 0 ? void 0 : review.reply) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (index_module_default()).replyContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mv0 !tw-text-[12px]/[18px] !tw-font-medium !tw-text-[#818181]",
                            children: [
                                "Seller's reply | ",
                                moment_default()(review === null || review === void 0 ? void 0 : review.reply_date).format("DD MMMM YYYY")
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "mv0 !tw-mt-[4px] !tw-text-[14px]/[18px] !tw-font-normal !tw-text-[#111C36]",
                            children: showCompleteReviewAndReply.reply ? review === null || review === void 0 ? void 0 : review.reply : review === null || review === void 0 ? void 0 : (ref4 = review.reply) === null || ref4 === void 0 ? void 0 : ref4.substr(0, 219)
                        }),
                        (review === null || review === void 0 ? void 0 : review.reply).length > 219 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "c28292C f14px fw5 pointer",
                            onClick: function() {
                                return setShowCompleteReviewAndReply(function(prevState) {
                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                                        reply: !showCompleteReviewAndReply.reply
                                    });
                                });
                            },
                            children: [
                                "... Read ",
                                showCompleteReviewAndReply.review ? "Less" : "More"
                            ]
                        }) : ""
                    ]
                }) : null
            ]
        })
    });
};
/* harmony default export */ var ReviewsSection_CustomerReviewReply = (CustomerReviewReply);

// EXTERNAL MODULE: ./src/components/CustomerReviewModal/index.js + 4 modules
var CustomerReviewModal = __webpack_require__(88557);
// EXTERNAL MODULE: ./src/components/Common/Modal/index.jsx
var Modal = __webpack_require__(672651);
;// CONCATENATED MODULE: ./src/components/ReviewsSection/VerifiedBuyerModal.js



var VerifiedBuyerModal = function(param) {
    var open = param.open, onClose = param.onClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        visible: open,
        className: "mobile-center-modal margin-top-modal-0",
        animation: "slideUp",
        width: 85,
        height: 150,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (index_module_default()).verifiedBuyerModal,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "mv0 f16px fw8",
                        children: "You haven’t purchased this item"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mv0 f14px fw4 pt14px",
                        children: "We only allow verified buyers to submit reviews. If you have any concerns, please share them with us directly and we would look into the same."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (index_module_default()).okBtnContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    onClick: onClose,
                    children: "OKAY"
                })
            })
        ]
    });
};
/* harmony default export */ var ReviewsSection_VerifiedBuyerModal = (VerifiedBuyerModal);

// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(186812);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/WIdgetPropertiesBasic/components/Button/index.tsx + 1 modules
var Button = __webpack_require__(846976);
// EXTERNAL MODULE: ./src/utils/getThemeColor.js
var getThemeColor = __webpack_require__(270758);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowBackIos.js
var ArrowBackIos = __webpack_require__(320724);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowForwardIos.js
var ArrowForwardIos = __webpack_require__(613379);
;// CONCATENATED MODULE: ./src/components/ReviewsSection/ProductReviewMedia/index.tsx









function ProductReviewMedia(props) {
    var reviews = props.reviews, isLoading = props.isLoading, handleProductReviewModalOpen = props.handleProductReviewModalOpen, canLoadMore = props.canLoadMore, onLoadMore = props.onLoadMore;
    var scrollRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), canScrollLeft = ref[0], setCanScrollLeft = ref[1];
    var ref1 = (0,react.useState)(false), canScrollRight = ref1[0], setCanScrollRight = ref1[1];
    var ref2 = (0,react.useState)(false), isScrollable = ref2[0], setIsScrollable = ref2[1];
    (0,react.useEffect)(function() {
        var el = scrollRef.current;
        if (!el) return;
        checkScrollButtons();
        el.addEventListener("scroll", checkScrollButtons);
        window.addEventListener("resize", checkScrollButtons);
        return function() {
            el.removeEventListener("scroll", checkScrollButtons);
            window.removeEventListener("resize", checkScrollButtons);
        };
    }, []);
    var checkScrollButtons = function() {
        var el = scrollRef.current;
        if (!el) return;
        var scrollable = el.scrollWidth > el.clientWidth;
        setIsScrollable(scrollable);
        setCanScrollLeft(el.scrollLeft > 0);
        setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
    };
    var scrollByAmount = function(amount) {
        var ref;
        (ref = scrollRef.current) === null || ref === void 0 ? void 0 : ref.scrollBy({
            left: amount,
            behavior: "smooth"
        });
    };
    if (!(reviews === null || reviews === void 0 ? void 0 : reviews.length)) {
        return null;
    }
    var themeColor = (0,getThemeColor/* getThemeColor */.p)();
    return (isLoading || !!(reviews === null || reviews === void 0 ? void 0 : reviews.length)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-mt-[40px] tw-flex tw-flex-col tw-gap-[16px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "tw-m-0",
                        children: "Customer photos & videos"
                    }),
                    !checkClientDeviceType/* IS_MOBILE */.q$ && isScrollable && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "tw-flex tw-gap-[2px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                onClick: function() {
                                    return scrollByAmount(-150);
                                },
                                className: classnames_default()("tw-flex", !canScrollLeft ? "tw-opacity-30" : ""),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBackIos["default"], {
                                    fontSize: "small",
                                    className: "!tw-p-0"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                onClick: function() {
                                    return scrollByAmount(150);
                                },
                                className: classnames_default()("tw-flex", !canScrollRight ? "tw-opacity-30" : ""),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForwardIos["default"], {
                                    fontSize: "small",
                                    className: "!tw-p-0"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-h-[110px] tw-items-center tw-gap-[16px] tw-overflow-scroll tw-scroll-smooth",
                ref: scrollRef,
                children: [
                    isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-h-full tw-w-full tw-animate-pulse tw-bg-slate-200"
                    }) : reviews === null || reviews === void 0 ? void 0 : reviews.map(function(review, index) {
                        var ref;
                        return review === null || review === void 0 ? void 0 : (ref = review.store_item_review_media) === null || ref === void 0 ? void 0 : ref.map(function(media, idx) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewMediaRendered, {
                                media: media,
                                onClick: function() {
                                    handleProductReviewModalOpen(index, idx);
                                },
                                size: checkClientDeviceType/* IS_MOBILE */.q$ ? 104 : 110
                            }, idx);
                        });
                    }),
                    canLoadMore && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        className: "!tw-h-fit !tw-w-fit tw-cursor-pointer tw-text-nowrap !tw-rounded-full !tw-px-[16px] !tw-py-[2px] tw-text-white",
                        backgroundColor: themeColor,
                        onClick: onLoadMore,
                        children: "More"
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/ArrowLeft.js
var ArrowLeft = __webpack_require__(927952);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/ArrowRight.js
var ArrowRight = __webpack_require__(532440);
// EXTERNAL MODULE: ./src/components/BasicModal/index.tsx
var BasicModal = __webpack_require__(475868);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var utils_constants = __webpack_require__(913886);
;// CONCATENATED MODULE: ./src/components/ReviewsSection/ProductReviewModal/index.tsx













function ProductReviewModal(param) {
    var modalState = param.modalState, setModalState = param.setModalState, reviews = param.reviews;
    var goToPrevReview = function goToPrevReview() {
        setModalState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, modalState), {
            reviewMediaIndex: 0,
            activeReviewIndex: modalState.activeReviewIndex - 1
        }));
    };
    var goToNextReview = function goToNextReview() {
        setModalState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, modalState), {
            reviewMediaIndex: 0,
            activeReviewIndex: modalState.activeReviewIndex + 1
        }));
    };
    var closeProductReviewModal = function closeProductReviewModal() {
        setModalState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, modalState), {
            show: false
        }));
    };
    var handlePrevClick = function handlePrevClick() {
        if (!isPrevButtonEnabled) {
            return;
        }
        if (isPrevMediaExists) {
            setActiveReviewMediaIndexLocal(activeReviewMediaIndexLocal - 1);
        } else {
            goToPrevReview();
        }
    };
    var handleNextClick = function handleNextClick() {
        if (!isNextButtonEnabled) {
            return;
        }
        if (isNextMediaExists) {
            setActiveReviewMediaIndexLocal(activeReviewMediaIndexLocal + 1);
        } else {
            goToNextReview();
        }
    };
    var renderMainMedia = function renderMainMedia(media) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tw-flex tw-h-[342px] tw-w-[272px] tw-flex-shrink-0 tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-[8px] tw-object-contain md:tw-h-[518px] md:tw-w-[434px]",
            children: (media === null || media === void 0 ? void 0 : media.media_type) === constants/* REVIEW_MEDIA_TYPE.VIDEO */.x.VIDEO ? /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                src: media === null || media === void 0 ? void 0 : media.media_url,
                controls: true,
                className: "tw-flex tw-max-h-full tw-max-w-full tw-rounded-[8px]"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: media === null || media === void 0 ? void 0 : media.media_url,
                className: "tw-flex tw-max-h-full tw-max-w-full tw-rounded-[8px]"
            })
        });
    };
    var ref = (0,react.useState)(0), activeReviewMediaIndexLocal = ref[0], setActiveReviewMediaIndexLocal = ref[1];
    var activeReviewIndex = modalState === null || modalState === void 0 ? void 0 : modalState.activeReviewIndex;
    var activeReviewMediaIndex = modalState.reviewMediaIndex;
    var totalReview = reviews.length;
    var review = reviews[modalState.activeReviewIndex];
    var reviewMedia = (review === null || review === void 0 ? void 0 : review.store_item_review_media) || [];
    var hasMedia = !!(reviewMedia === null || reviewMedia === void 0 ? void 0 : reviewMedia.length);
    var isPreviousReviewExists = activeReviewIndex > 0;
    var isNextReviewExists = activeReviewIndex < totalReview - 1;
    // these 4 are used only on Desktop
    var isPrevMediaExists = activeReviewMediaIndexLocal > 0;
    var isNextMediaExists = activeReviewMediaIndexLocal < (reviewMedia === null || reviewMedia === void 0 ? void 0 : reviewMedia.length) - 1;
    var isPrevButtonEnabled = isPrevMediaExists || isPreviousReviewExists;
    var isNextButtonEnabled = isNextMediaExists || isNextReviewExists;
    (0,react.useEffect)(function() {
        setActiveReviewMediaIndexLocal(activeReviewMediaIndex || 0);
    }, [
        review
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BasicModal/* default */.Z, {
        show: true,
        onClose: closeProductReviewModal,
        heading: "Product review",
        headingClasses: "!tw-px-[16px] md:!tw-px-[24px] !tw-overflow-visible",
        customClasses: "!tw-w-full md:!tw-min-w-[780px] !tw-overflow-auto md:!tw-overflow-visible !tw-m-0",
        children: [
            !checkClientDeviceType/* IS_MOBILE */.q$ && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                onClick: handlePrevClick,
                className: classnames_default()("pointer tw-absolute -tw-left-[77px] tw-top-[50%] tw-flex tw-h-[35px] tw-w-[35px] -tw-translate-y-1/2 tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-full tw-border-[3px] tw-border-solid tw-border-white tw-text-white", !isPrevButtonEnabled ? "tw-opacity-40" : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLeft/* default */.Z, {
                    fontSize: "large"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-h-full tw-w-full tw-flex-col md:tw-flex-row",
                children: [
                    !checkClientDeviceType/* IS_MOBILE */.q$ && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-p-[24px]",
                        children: hasMedia ? renderMainMedia(reviewMedia === null || reviewMedia === void 0 ? void 0 : reviewMedia[activeReviewMediaIndexLocal]) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-flex tw-h-[342px] tw-w-[272px] tw-items-center tw-justify-center md:tw-h-[518px] md:tw-w-[434px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-flex tw-w-[132px] tw-flex-col tw-items-center tw-gap-[16px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: utils_constants/* DEFAULT_IMAGE_OBJECT.image_url */.M0.image_url,
                                        className: "tw-w-ful"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "tw-m-0 tw-text-[13px]/[18px] tw-font-medium tw-italic tw-text-[#969696]",
                                        children: "No media attatched"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()("tw-flex tw-flex-1 tw-flex-col tw-gap-[16px] tw-border-l tw-border-solid tw-border-[#111C361F] tw-p-[24px] tw-px-[20px]", checkClientDeviceType/* IS_MOBILE */.q$ && totalReview > 1 ? "tw-pb-[80px]" : ""),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewerInfo, {
                                review: review
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-mb-[12px] tw-flex tw-gap-[12px] tw-text-[13px]/[18px] tw-font-normal tw-text-[#111C36]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "!tw-m-0",
                                    children: review === null || review === void 0 ? void 0 : review.review
                                })
                            }),
                            !checkClientDeviceType/* IS_MOBILE */.q$ && hasMedia && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-flex tw-flex-col tw-gap-[12px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "!tw-m-0 tw-text-[12px]/[18px] tw-font-medium tw-text-black",
                                        children: "Media in this review"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "tw-flex tw-gap-[10px]",
                                        children: reviewMedia === null || reviewMedia === void 0 ? void 0 : reviewMedia.map(function(media, index) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                className: classnames_default()("border-grey1 tw-relative tw-flex tw-h-[67px] tw-w-[67px] tw-cursor-pointer tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-[4px] tw-border-[2px] tw-border-solid tw-object-contain", index === activeReviewMediaIndexLocal ? "tw-border-[#2B74D8]" : "tw-border-[#111C361F]"),
                                                onClick: function() {
                                                    return setActiveReviewMediaIndexLocal(index);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: (media === null || media === void 0 ? void 0 : media.thumbnail_url) || (media === null || media === void 0 ? void 0 : media.media_url),
                                                        className: "tw-flex tw-max-h-full tw-max-w-full"
                                                    }),
                                                    (media === null || media === void 0 ? void 0 : media.media_type) === constants/* REVIEW_MEDIA_TYPE.VIDEO */.x.VIDEO && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "tw-absolute tw-inset-0 tw-bg-[#00000059]",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "tw-absolute tw-left-[50%] tw-top-[50%] tw-flex -tw-translate-x-1/2 -tw-translate-y-1/2 tw-text-white",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayCircleOutlineRounded["default"], {})
                                                        })
                                                    })
                                                ]
                                            }, index);
                                        })
                                    })
                                ]
                            }),
                            checkClientDeviceType/* IS_MOBILE */.q$ && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-flex tw-items-center tw-gap-[16px] tw-overflow-scroll tw-scroll-smooth tw-pb-[42px]",
                                children: reviewMedia === null || reviewMedia === void 0 ? void 0 : reviewMedia.map(function(media, index) {
                                    return renderMainMedia(media);
                                })
                            })
                        ]
                    })
                ]
            }),
            checkClientDeviceType/* IS_MOBILE */.q$ && totalReview > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-fixed tw-bottom-0 tw-flex tw-w-full tw-justify-between tw-border-t tw-border-solid tw-border-[#111C361F] tw-bg-white tw-p-[20px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        disabled: !isPreviousReviewExists,
                        variant: "secondary",
                        className: classnames_default()("!tw-h-[36px] !tw-border-[#2B74D8] !tw-px-[16px] !tw-py-[8px] !tw-text-[#2B74D8]", !isPreviousReviewExists ? "tw-opacity-40" : ""),
                        onClick: isPreviousReviewExists && goToPrevReview,
                        children: "Previous"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        disabled: !isNextReviewExists,
                        variant: "secondary",
                        className: classnames_default()("!tw-h-[36px] !tw-border-[#2B74D8] !tw-px-[16px] !tw-py-[8px] !tw-text-[#2B74D8]", !isNextReviewExists ? "tw-opacity-40" : ""),
                        onClick: isNextReviewExists && goToNextReview,
                        children: "Next review"
                    })
                ]
            }),
            !checkClientDeviceType/* IS_MOBILE */.q$ && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                onClick: handleNextClick,
                className: classnames_default()("pointer tw-absolute -tw-right-[77px] tw-top-[50%] tw-flex tw-h-[35px] tw-w-[35px] -tw-translate-y-1/2 tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-full tw-border-[3px] tw-border-solid tw-border-white tw-text-white", !isNextButtonEnabled ? "tw-opacity-40" : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRight/* default */.Z, {
                    fontSize: "large"
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/ReviewsSection/index.js
















var REVIEW_TYPE = {
    ALL: 0,
    WITH_MEDIA: 1
};
var ReviewsSection = function(param) {
    var product = param.product, shouldReviewItem = param.shouldReviewItem;
    var getReviews = function getReviews(isReset, isAllReviews) {
        var reviewConfig = isAllReviews ? allReviewPaginationConfig : reviewWithMediaPaginationConfig;
        var setReviewConfig = isAllReviews ? setAllReviewPaginationConfig : setReviewWithMediaPaginationConfig;
        var reviews = isAllReviews ? allReviews : reviewsWithMedia;
        var setReviews = isAllReviews ? setAllReview : setReviewsWithMedia;
        var currentPage = !isReset ? reviewConfig.pageNum : 1;
        var isNextPage = !isReset ? reviewConfig.isNextPage : true;
        if (!isNextPage) {
            return;
        }
        var params = {
            storeId: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id,
            itemId: product === null || product === void 0 ? void 0 : product.id,
            pageNum: currentPage,
            media: isAllReviews ? REVIEW_TYPE.ALL : REVIEW_TYPE.WITH_MEDIA
        };
        dispatch((0,catalog/* getProductReviews */.mk)(params, function(status, data) {
            if (status) {
                var ref;
                var isNextPage = currentPage < (data === null || data === void 0 ? void 0 : data.total_page);
                var newList = !isReset ? (0,_to_consumable_array/* default */.Z)(reviews).concat((0,_to_consumable_array/* default */.Z)((data === null || data === void 0 ? void 0 : data.review_rating) || [])) : (data === null || data === void 0 ? void 0 : data.review_rating) || [];
                isAllReviews && setProductReviewCount({
                    avgRating: newList === null || newList === void 0 ? void 0 : (ref = newList[0]) === null || ref === void 0 ? void 0 : ref.avg_rating,
                    ratingCount: data === null || data === void 0 ? void 0 : data.ratings_count,
                    reviewCount: data === null || data === void 0 ? void 0 : data.reviews_count
                });
                setReviewConfig({
                    pageNum: currentPage + 1,
                    isNextPage: isNextPage
                });
                setReviews(newList);
            }
        }));
    };
    var getAllProductReviews = function getAllProductReviews() {
        var isReset = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        getReviews(isReset, true);
    };
    var getProductReviewsWithMedia = function getProductReviewsWithMedia() {
        var isReset = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        getReviews(isReset, false);
    };
    var handleProductReviewModalOpen = function handleProductReviewModalOpen(reviewIndex, mediaIndex) {
        var type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : REVIEW_TYPE.WITH_MEDIA;
        setProductReviewModalState({
            show: true,
            type: type,
            activeReviewIndex: reviewIndex,
            reviewMediaIndex: mediaIndex
        });
    };
    var ref;
    var themeColor = (0,getThemeColor/* getThemeColor */.p)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref1 = (0,react.useState)(false), openCustomerReviewModal = ref1[0], setOpenCustomerReviewModal = ref1[1];
    var ref2 = (0,react.useState)({
        show: false,
        type: REVIEW_TYPE.WITH_MEDIA,
        activeReviewIndex: 0,
        reviewMediaIndex: 0
    }), productReviewModalState = ref2[0], setProductReviewModalState = ref2[1];
    var ref3 = (0,react.useState)(false), openVerifiedModal = ref3[0], setOpenVerifiedModal = ref3[1];
    var ref4 = (0,es/* useSelector */.v9)(function(state) {
        return {
            userData: state.userReducer,
            storeInfo: state.storeReducer.store
        };
    }), userData = ref4.userData, storeInfo = ref4.storeInfo;
    var ref5 = (0,react.useState)({
        avgRating: 0,
        ratingCount: 0,
        reviewCount: 0
    }), productReviewCount = ref5[0], setProductReviewCount = ref5[1];
    var ref6 = (0,react.useState)([]), allReviews = ref6[0], setAllReview = ref6[1];
    var ref7 = (0,react.useState)([]), reviewsWithMedia = ref7[0], setReviewsWithMedia = ref7[1];
    var productReviewModalReviews = productReviewModalState.type === REVIEW_TYPE.ALL ? allReviews : reviewsWithMedia;
    var ref8 = (0,react.useState)({
        pageNum: 1,
        isNextPage: true
    }), allReviewPaginationConfig = ref8[0], setAllReviewPaginationConfig = ref8[1];
    var ref9 = (0,react.useState)({
        pageNum: 1,
        isNextPage: true
    }), reviewWithMediaPaginationConfig = ref9[0], setReviewWithMediaPaginationConfig = ref9[1];
    (0,react.useEffect)(function() {
        getAllProductReviews();
        getProductReviewsWithMedia();
    }, [
        product
    ]);
    var loggedInUserReview = allReviews === null || allReviews === void 0 ? void 0 : allReviews.find(function(review) {
        var ref, ref1, ref2;
        return (userData === null || userData === void 0 ? void 0 : (ref = userData.data) === null || ref === void 0 ? void 0 : ref.phone) ? (review === null || review === void 0 ? void 0 : review.phone) === (userData === null || userData === void 0 ? void 0 : (ref1 = userData.data) === null || ref1 === void 0 ? void 0 : ref1.phone) : (review === null || review === void 0 ? void 0 : review.user_id) === (userData === null || userData === void 0 ? void 0 : (ref2 = userData.data) === null || ref2 === void 0 ? void 0 : ref2.user_id);
    });
    var handleCustomerReviewModalOpen = function() {
        if (!shouldReviewItem() && deviceWidth/* deviceWidth */.o > 767) return;
        if (!shouldReviewItem() && deviceWidth/* deviceWidth */.o <= 767) {
            setOpenVerifiedModal(true);
            return;
        }
        setOpenCustomerReviewModal(true);
    };
    var handleCustomerReviewModalClose = function() {
        setOpenCustomerReviewModal(false);
        getAllProductReviews(true);
        getProductReviewsWithMedia(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "reviews-section",
                className: (index_module_default()).reviewsSectionContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between tw-flex-col tw-gap-[32px] md:tw-flex-row md:tw-items-end",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                className: "mv0 fw6 f18px tw-flex tw-flex-col tw-gap-[16px] md:tw-gap-[32px]",
                                children: [
                                    (allReviews === null || allReviews === void 0 ? void 0 : allReviews.length) ? "Ratings & Reviews" : "No Reviews yet",
                                    (productReviewCount === null || productReviewCount === void 0 ? void 0 : productReviewCount.ratingCount) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "mv0 fw6 c44454A pr8px tw-text-[30px]",
                                                    children: productReviewCount === null || productReviewCount === void 0 ? void 0 : (ref = productReviewCount.avgRating) === null || ref === void 0 ? void 0 : ref.toFixed(1)
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-end",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RatingStar, {
                                                            rating: productReviewCount === null || productReviewCount === void 0 ? void 0 : productReviewCount.avgRating
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            className: "mv0 pl16px fw5 f14px c44454A",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: productReviewCount === null || productReviewCount === void 0 ? void 0 : productReviewCount.ratingCount
                                                                }),
                                                                " Ratings &",
                                                                " ",
                                                                productReviewCount === null || productReviewCount === void 0 ? void 0 : productReviewCount.reviewCount,
                                                                " Reviews"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }) : null
                                ]
                            }),
                            (userData === null || userData === void 0 ? void 0 : userData.isLogin) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        style: {
                                            opacity: shouldReviewItem() ? 1 : 0.21,
                                            border: "1px solid ".concat(themeColor || "#5c3cb7"),
                                            color: themeColor || "#5b3bb7"
                                        },
                                        className: classnames_default()((index_module_default()).writeReviewBtn, "!tw-w-full md:!tw-w-[130px]"),
                                        onClick: handleCustomerReviewModalOpen,
                                        "data-tip": true,
                                        "data-for": "write-a-review",
                                        children: (loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.review) ? "Edit Review" : "Write a Review"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                                        id: "write-a-review",
                                        place: "bottom",
                                        effect: "solid",
                                        multiline: true,
                                        padding: "8px",
                                        disable: shouldReviewItem() || deviceWidth/* deviceWidth */.o <= 767,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "mv0 fw5 f12px",
                                            children: [
                                                "Only buyers of this item can submit reviews. If you have any",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                "concerns, please share them with us and we would look into it."
                                            ]
                                        })
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductReviewMedia, {
                        reviews: reviewsWithMedia,
                        handleProductReviewModalOpen: handleProductReviewModalOpen,
                        canLoadMore: reviewWithMediaPaginationConfig.isNextPage,
                        onLoadMore: function() {
                            return getProductReviewsWithMedia();
                        }
                    }),
                    !!(allReviews === null || allReviews === void 0 ? void 0 : allReviews.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-mt-[20px] tw-border-t tw-border-solid tw-border-[#DEDEDE] md:tw-mt-[36px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "tw-m-0 tw-pt-[32px] tw-text-[18px]/[20px] tw-font-medium tw-text-black md:tw-pt-[36px]",
                                        children: "All Reviews"
                                    }),
                                    allReviews === null || allReviews === void 0 ? void 0 : allReviews.map(function(review, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewsSection_CustomerReviewReply, {
                                            review: review,
                                            handleProductReviewModalOpen: function(mediaIndex) {
                                                return handleProductReviewModalOpen(index, mediaIndex, REVIEW_TYPE.ALL);
                                            }
                                        }, index);
                                    })
                                ]
                            }),
                            !!(allReviewPaginationConfig === null || allReviewPaginationConfig === void 0 ? void 0 : allReviewPaginationConfig.isNextPage) && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: function() {
                                    return getAllProductReviews();
                                },
                                style: {
                                    color: themeColor,
                                    borderColor: themeColor
                                },
                                className: "tw-mx-auto tw-mt-[18px] tw-h-[54px] tw-w-[242px] tw-border tw-border-solid tw-bg-transparent",
                                children: "See more reviews"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerReviewModal/* default */.Z, {
                open: openCustomerReviewModal,
                onClose: function() {
                    return setOpenCustomerReviewModal(false);
                },
                onSubmit: handleCustomerReviewModalClose,
                product: product,
                loggedInUserReview: loggedInUserReview
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewsSection_VerifiedBuyerModal, {
                open: openVerifiedModal,
                onClose: function() {
                    return setOpenVerifiedModal(false);
                }
            }),
            productReviewModalState.show && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductReviewModal, {
                modalState: productReviewModalState,
                reviews: productReviewModalReviews,
                setModalState: setProductReviewModalState
            })
        ]
    });
};
/* harmony default export */ var components_ReviewsSection = (ReviewsSection);


/***/ }),

/***/ 916873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(913886);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(667294);
/* harmony import */ var _utils_getStoreType__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66871);
/* harmony import */ var _redux_ssrStore__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(326706);






var SSRadioGroup = function(param) {
    var itemList = param.itemList, activeIdx = param.activeIdx, onChange = param.onChange, _itemLowQty = param.itemLowQty, itemLowQty = _itemLowQty === void 0 ? 0 : _itemLowQty;
    var isVariantHidden = function isVariantHidden(item) {
        return (item === null || item === void 0 ? void 0 : item.status) === _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .ITEM_ACTIVE_STATUS.HIDDEN */ .p4.HIDDEN;
    };
    var storeInfo = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_4__/* .useSSRSelector */ .kF)(function(state) {
        return {
            storeInfo: state.storeReducer.store
        };
    }).storeInfo;
    var theme = storeInfo.theme;
    var isB2bStore = (0,_utils_getStoreType__WEBPACK_IMPORTED_MODULE_3__/* .getStoreType */ .K)(storeInfo) === _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .STORE_CUSTOMIZATION.B2B */ .DO.B2B;
    var checkLimitedQty = function(el) {
        return !!(el === null || el === void 0 ? void 0 : el.managed_inventory) && !!itemLowQty && (el === null || el === void 0 ? void 0 : el.available_quantity) <= itemLowQty;
    };
    var checkIfItemIsOutOfStock = function(el) {
        if (!!(el === null || el === void 0 ? void 0 : el.managed_inventory)) {
            return el.available === 0 && el.available_quantity === 0;
        }
        return el.available === 0;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "single-select-radio-groups",
        children: itemList && (itemList === null || itemList === void 0 ? void 0 : itemList.map(function(el, ind) {
            var ref, ref1, ref2, ref3;
            return !isVariantHidden(el) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
                className: "radio-item ".concat(checkIfItemIsOutOfStock(el) && "out-of-stock", " ").concat(ind === activeIdx && "active", " flex justify-between items-center pointer"),
                onClick: function() {
                    return onChange(ind, el);
                },
                style: {
                    color: "".concat(ind !== activeIdx ? "#000" : theme ? theme === null || theme === void 0 ? void 0 : (ref = theme.colors) === null || ref === void 0 ? void 0 : ref.primary_color : "#EA5151"),
                    borderColor: "".concat(ind !== activeIdx ? "#DEDEDE" : theme ? theme === null || theme === void 0 ? void 0 : (ref1 = theme.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color : "#EA5151")
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex-auto flex justify-start items-center",
                        children: [
                            el.images && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: el === null || el === void 0 ? void 0 : (ref2 = el.images) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.image_url,
                                className: "img h3"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "w-100 ml3",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "fw5 ".concat(checkLimitedQty(el) ? "mt0 mb1" : "mt1 mb2"),
                                        children: el.variant_name
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        className: "mv1 black",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                className: "fw4",
                                                children: [
                                                    "₹",
                                                    el === null || el === void 0 ? void 0 : el.discounted_price
                                                ]
                                            }),
                                            (el === null || el === void 0 ? void 0 : el.discounted_price) < (el === null || el === void 0 ? void 0 : el.price) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                className: "strike ml2 f7 black-50 fw4",
                                                children: [
                                                    "₹",
                                                    el === null || el === void 0 ? void 0 : el.price
                                                ]
                                            })
                                        ]
                                    }),
                                    !isB2bStore && checkLimitedQty(el) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "highlighter-red-color inventory-change fw4",
                                        children: el.available_quantity ? "Hurry! Only ".concat(el.available_quantity, " units left!") : "Out of stock"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        type: "radio",
                        name: "variant-group",
                        checked: ind === activeIdx,
                        className: "h1 w1"
                    })
                ]
            }, "variant-list-modal-".concat(ind));
        }))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SSRadioGroup);


/***/ }),

/***/ 406632:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Wishlist_WishlistHeartButton; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(999534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
;// CONCATENATED MODULE: ./src/assets/svgExports/WishlistActiveHeartButtonIcon.js

var WishlistActiveHeartButtonIcon = function(param) {
    var _iconType = param.iconType, iconType = _iconType === void 0 ? "filled" : _iconType, _iconColor = param.iconColor, iconColor = _iconColor === void 0 ? "#DF2121" : _iconColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "11.7778",
                fill: iconType === "filled" ? "white" : "none",
                stroke: iconType === "filled" ? "#E0E0E0" : "none",
                "stroke-width": "0.445154"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.1369 18.7992C12.0068 18.7992 11.8782 18.7757 11.7511 18.7287C11.6239 18.6816 11.5119 18.6098 11.4152 18.5132L10.6487 17.8217C9.46043 16.7432 8.41193 15.6946 7.50314 14.6757C6.59447 13.6567 6.14014 12.5978 6.14014 11.4988C6.14014 10.6504 6.42865 9.93807 7.00568 9.36174C7.5826 8.78529 8.29569 8.49707 9.14493 8.49707C9.63204 8.49707 10.1392 8.62003 10.6665 8.86595C11.1939 9.11176 11.6883 9.57547 12.1497 10.2571C12.6111 9.57547 13.1055 9.11176 13.6329 8.86595C14.1602 8.62003 14.6674 8.49707 15.1545 8.49707C16.0038 8.49707 16.7168 8.78529 17.2938 9.36174C17.8708 9.93807 18.1593 10.6504 18.1593 11.4988C18.1593 12.6234 17.6863 13.7043 16.7404 14.7417C15.7944 15.7791 14.759 16.807 13.6341 17.8255L12.8714 18.5132C12.7747 18.6098 12.6606 18.6816 12.5292 18.7287C12.3977 18.7757 12.267 18.7992 12.1369 18.7992Z",
                fill: iconColor
            })
        ]
    });
};
/* harmony default export */ var svgExports_WishlistActiveHeartButtonIcon = (WishlistActiveHeartButtonIcon);

;// CONCATENATED MODULE: ./src/assets/svgExports/WishlistHeartButtonIcon.js

var WishlistHeartButtonIcon = function(param) {
    var _iconType = param.iconType, iconType = _iconType === void 0 ? "filled" : _iconType;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "11.7778",
                fill: iconType === "filled" ? "white" : "none",
                stroke: iconType === "filled" ? "#E0E0E0" : "none",
                "stroke-width": "0.444444"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.9872 18C11.8573 18 11.7289 17.9772 11.602 17.9315C11.475 17.8859 11.3632 17.8162 11.2667 17.7224L10.5013 17.0511C9.315 16.0043 8.26817 14.9864 7.36083 13.9974C6.45361 13.0083 6 11.9804 6 10.9137C6 10.0902 6.28806 9.39874 6.86417 8.83931C7.44017 8.27977 8.15211 8 9 8C9.48633 8 9.99272 8.11935 10.5192 8.35806C11.0457 8.59666 11.5393 9.04678 12 9.7084C12.4607 9.04678 12.9543 8.59666 13.4808 8.35806C14.0073 8.11935 14.5137 8 15 8C15.8479 8 16.5598 8.27977 17.1358 8.83931C17.7119 9.39874 18 10.0902 18 10.9137C18 12.0053 17.5278 13.0545 16.5833 14.0615C15.6389 15.0684 14.6051 16.0662 13.482 17.0548L12.7205 17.7224C12.6239 17.8162 12.5101 17.8859 12.3788 17.9315C12.2476 17.9772 12.1171 18 11.9872 18ZM11.6743 10.3808C11.2752 9.75567 10.8603 9.31052 10.4295 9.04537C9.99872 8.78012 9.52222 8.64749 9 8.64749C8.33333 8.64749 7.77778 8.86332 7.33333 9.29498C6.88889 9.72664 6.66667 10.2662 6.66667 10.9137C6.66667 11.3919 6.806 11.8822 7.08467 12.3848C7.36322 12.8875 7.73733 13.4024 8.207 13.9296C8.67667 14.4566 9.21644 14.9958 9.82633 15.547C10.4361 16.0982 11.0709 16.6656 11.7308 17.2491C11.8077 17.3155 11.8974 17.3488 12 17.3488C12.1026 17.3488 12.1923 17.3155 12.2692 17.2491C12.9291 16.6656 13.5639 16.0982 14.1737 15.547C14.7836 14.9958 15.3233 14.4566 15.793 13.9296C16.2627 13.4024 16.6368 12.8875 16.9153 12.3848C17.194 11.8822 17.3333 11.3919 17.3333 10.9137C17.3333 10.2662 17.1111 9.72664 16.6667 9.29498C16.2222 8.86332 15.6667 8.64749 15 8.64749C14.4778 8.64749 14.0013 8.78012 13.5705 9.04537C13.1397 9.31052 12.7248 9.75567 12.3257 10.3808C12.2906 10.4389 12.2431 10.4824 12.1833 10.5115C12.1236 10.5406 12.0624 10.5552 12 10.5552C11.9376 10.5552 11.8764 10.5406 11.8167 10.5115C11.7569 10.4824 11.7094 10.4389 11.6743 10.3808Z",
                fill: iconType === "filled" ? "#1C1B1F" : "white"
            })
        ]
    });
};
/* harmony default export */ var svgExports_WishlistHeartButtonIcon = (WishlistHeartButtonIcon);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/constants/wishlist.js
var wishlist = __webpack_require__(298627);
// EXTERNAL MODULE: ./src/hooks/useFeatureLocks.ts
var useFeatureLocks = __webpack_require__(482516);
;// CONCATENATED MODULE: ./src/components/Wishlist/WishlistHeartButton.tsx








var WishlistHeartButton = function(_param) {
    var isActive = _param.isActive, _scale = _param.scale, scale = _scale === void 0 ? 1 : _scale, props = (0,_object_without_properties/* default */.Z)(_param, [
        "isActive",
        "scale"
    ]);
    var wishlistFeatureActive = (0,es/* useSelector */.v9)(function(state) {
        var ref, ref1, ref2;
        return {
            wishlistFeatureActive: (ref = state.storeReducer) === null || ref === void 0 ? void 0 : (ref1 = ref.store) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.services) === null || ref2 === void 0 ? void 0 : ref2.wishlist_flag
        };
    }).wishlistFeatureActive;
    var wishlistFeatureStatus = (0,useFeatureLocks/* useFeatureLocks */.r)().wishlistFeatureStatus;
    return wishlistFeatureActive === wishlist/* WISHLIST_FEATURE_STATUS.WISHLIST_ACTIVE */.g.WISHLIST_ACTIVE && !(wishlistFeatureStatus === null || wishlistFeatureStatus === void 0 ? void 0 : wishlistFeatureStatus.isLocked) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat(props === null || props === void 0 ? void 0 : props.customClassName, " ").concat((props === null || props === void 0 ? void 0 : props.iconType) && (props === null || props === void 0 ? void 0 : props.iconType) === "transparent" ? "" : "tw-transition-shadow tw-duration-200 hover:tw-shadow-[0_8px_20px_rgba(0,0,0,0.25)]"),
        style: {
            transform: "scale(".concat(scale, ")"),
            lineHeight: 0,
            borderRadius: "50%"
        },
        children: isActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)(svgExports_WishlistActiveHeartButtonIcon, (0,_object_spread/* default */.Z)({}, props)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(svgExports_WishlistHeartButtonIcon, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var Wishlist_WishlistHeartButton = (WishlistHeartButton);


/***/ }),

/***/ 810445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ PROMO_APPLICABILITY_TYPES; }
/* harmony export */ });
/* unused harmony export PROMO_TYPES */
var PROMO_TYPES = {
    GENERAL: 1,
    PRODUCT: 2,
    TAG: 3,
    CATEGORY: 4,
    COLLECTION: 5,
    BUYXGETY: 6
};
var PROMO_APPLICABILITY_TYPES = {
    PRODUCT: 1,
    TAG: 2,
    CATEGORY: 3,
    COLLECTION: 4
};


/***/ }),

/***/ 310862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hooks_useItemScheduler; }
});

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/redux/actions/common.js
var common = __webpack_require__(731024);
// EXTERNAL MODULE: ./src/redux/actions/cart.js
var cart = __webpack_require__(666162);
;// CONCATENATED MODULE: ./src/utils/deepClone.js
var deepClone = function(obj) {
    return JSON.parse(JSON.stringify(obj));
};
/* harmony default export */ var utils_deepClone = (deepClone);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./src/utils/itemIndexFromCart.js
var itemIndexFromCart = __webpack_require__(648670);
;// CONCATENATED MODULE: ./src/utils/addScheduleInfo.js



function addScheduleInfoToCart(cartData, product, scheduleInfo) {
    var ref;
    var idx = (0,itemIndexFromCart/* itemIndexFromCart */.R)(cartData, product);
    var cartItem = cartData === null || cartData === void 0 ? void 0 : (ref = cartData.items) === null || ref === void 0 ? void 0 : ref[idx];
    if (scheduleInfo && cartItem) {
        cartItem.schedule_info = (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cartItem.schedule_info || {}), {
            item_id: product === null || product === void 0 ? void 0 : product.id
        }), scheduleInfo);
    }
}

;// CONCATENATED MODULE: ./src/hooks/useItemScheduler.ts




var useItemScheduler = function() {
    var setScheduleData = function setScheduleData(data) {
        dispatch((0,common/* setScheduleInfo */.Hp)(data));
    };
    var changeSchedulingInfoAndSetCart = function changeSchedulingInfoAndSetCart(newSchedulingInfo, itemIndexInCart) {
        if (itemIndexInCart >= 0) {
            var ref;
            var newCartData = utils_deepClone(cartData);
            var item = newCartData === null || newCartData === void 0 ? void 0 : (ref = newCartData.items) === null || ref === void 0 ? void 0 : ref[itemIndexInCart];
            if (item) {
                item.schedule_info = newSchedulingInfo;
                dispatch((0,cart/* setCart */.RV)(newCartData));
            }
        }
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    var cartData = (0,es/* useSelector */.v9)(function(state) {
        return {
            cartData: state.cartReducer
        };
    }).cartData;
    return {
        setScheduleData: setScheduleData,
        changeSchedulingInfoAndSetCart: changeSchedulingInfoAndSetCart,
        addScheduleInfoToCart: addScheduleInfoToCart
    };
};
/* harmony default export */ var hooks_useItemScheduler = (useItemScheduler);


/***/ }),

/***/ 427994:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ checkForLimitedQuantity; }
/* harmony export */ });
/**
 * check if stocks are low in quantity
 * @param {*} stockItem
 * @return {boolean} boolean
 */ var checkForLimitedQuantity = function(stockItem) {
    if (!((stockItem === null || stockItem === void 0 ? void 0 : stockItem.managed_inventory) && (stockItem === null || stockItem === void 0 ? void 0 : stockItem.available_quantity) && (stockItem === null || stockItem === void 0 ? void 0 : stockItem.low_quantity))) {
        return false;
    }
    return stockItem.available_quantity <= stockItem.low_quantity;
};


/***/ }),

/***/ 544990:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ getItemAmountForPDP; }
/* harmony export */ });
/**
 * calculate and return discounted price and price of item
 * @param {object} product
 * @param {number} selectedVariantIndex
 * @return {object}
 */ var getItemAmountForPDP = function(product, selectedVariantIndex) {
    var ref;
    var amount = {
        discounted_price: 0,
        price: 0,
        price_range: ""
    };
    if (selectedVariantIndex > -1 && (product === null || product === void 0 ? void 0 : (ref = product.variants) === null || ref === void 0 ? void 0 : ref.length)) {
        var ref1, ref2, ref3, ref4, ref5;
        amount.discounted_price = product === null || product === void 0 ? void 0 : (ref1 = product.variants) === null || ref1 === void 0 ? void 0 : ref1[selectedVariantIndex].discounted_price;
        amount.price = product === null || product === void 0 ? void 0 : (ref2 = product.variants) === null || ref2 === void 0 ? void 0 : ref2[selectedVariantIndex].price;
        amount.price_range = product === null || product === void 0 ? void 0 : (ref3 = product.variants) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[selectedVariantIndex]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.b2b_pricing_info) === null || ref5 === void 0 ? void 0 : ref5.price_range;
    } else {
        var ref6;
        amount.discounted_price = product.discounted_price;
        amount.price = product.price;
        amount.price_range = product === null || product === void 0 ? void 0 : (ref6 = product.b2b_pricing_info) === null || ref6 === void 0 ? void 0 : ref6.price_range;
    }
    return amount;
};


/***/ }),

/***/ 532953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isNotifyProductEnabled; }
/* harmony export */ });
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17247);

var isNotifyProductEnabled = function() {
    var ref;
    var storeData = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().storeReducer.store;
    if ((storeData === null || storeData === void 0 ? void 0 : (ref = storeData.services) === null || ref === void 0 ? void 0 : ref.notify_me_enabled) === 1) {
        return true;
    }
    return false;
};


/***/ }),

/***/ 673220:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ratingBoxContainer":"RatingBox_ratingBoxContainer__xpD_F","ratingBox":"RatingBox_ratingBox__iK6eT","updatedNoOfRating":"RatingBox_updatedNoOfRating__DByU7","updatedRatingBox":"RatingBox_updatedRatingBox__aI92N"};

/***/ }),

/***/ 325525:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"reviewsSectionContainer":"ReviewsSection_reviewsSectionContainer__Vh9sq","writeReviewBtn":"ReviewsSection_writeReviewBtn__NBgmA","customerReviewReplyContainer":"ReviewsSection_customerReviewReplyContainer__5G1L5","readMore":"ReviewsSection_readMore__z9m8T","replyContainer":"ReviewsSection_replyContainer__GZSEk","verifiedBuyerModal":"ReviewsSection_verifiedBuyerModal__mMlQT","okBtnContainer":"ReviewsSection_okBtnContainer__bI_ig"};

/***/ })

}]);